// IE polyfill
import  "./polyfill";
import  "core-js/es";
import  "mutation-observer";
import  "react-app-polyfill/ie9";
import  "react-app-polyfill/stable";

import React from 'react';
import ReactDOM from 'react-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';

import App from './App';
// import * as serviceWorker from './serviceWorker';

// 创建cnzz统计js start
	const script = document.createElement('script')  
	script.src = 'https://s23.cnzz.com/stat.php?id=5817996&web_id=5817996'
	script.language = 'JavaScript'  
	document.body.appendChild(script)  
// 创建cnzz统计js end

ReactDOM.render(
	<ConfigProvider locale={zhCN}>
		<App />
	</ConfigProvider>
	, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
